import {
    IonButton,
    IonHeader,
    IonModal,
    IonTitle,
    IonToolbar,
} from '@ionic/react';
import { Trans } from '@lingui/macro';
import React from 'react';

import classes from './ConfirmationModal.module.css';

interface ConfirmationModalProps {
    onYes: () => void;
    onNo: () => void;
    isOpen: boolean;
    modalMessage: JSX.Element;
}

const ConfirmationModal: React.FunctionComponent<ConfirmationModalProps> = ({
    isOpen,
    onYes,
    onNo,
    modalMessage,
}) => {
    return (
        <IonModal
            className={classes.confirmationModal}
            isOpen={isOpen}
            backdropDismiss={false}
        >
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Confirmation</IonTitle>
                </IonToolbar>
            </IonHeader>
            <div className={classes.confirmationModalContent}>
                {modalMessage}
                <div className={classes.confirmationButtonContainer}>
                    <IonButton onClick={onYes}>
                        <Trans>Yes</Trans>
                    </IonButton>
                    <IonButton onClick={onNo}>
                        <Trans>No</Trans>
                    </IonButton>
                </div>
            </div>
        </IonModal>
    );
};

export default ConfirmationModal;
